module.exports = __webpack_public_path__ + "img/bar.6a61dfa4.png";